export const commonParams = {
  pageSize: 20
};

export const api = {
  getCodeUrl: '/basiCP/ub/pre',
  loginUrl: '/basiCP/ub/login',
  logoutUrl: '/basiCP/ub/logout',
  courseUrl: '/basiCP/course',
  coursesUrl: '/basiCP/course/s',
  activityUrl: '/basiCP/priceScale',
  activityCourseUrl: '/basiCP/priceScale/course',
  inActivityCourseUrl: '/basiCP/priceScale/courseNON',
  schoolUrl: '/basiCP/school',
  schoolsUrl: '/basiCP/school/s',
  coachListUrl: '/basiCP/instructor/query',
  coachUrl: '/basiCP/instructor',
  addCoachesUrl: '/basiCP/instructor/addBatchVerify',
  saveCoachesUrl: '/basiCP/instructor/saveBatch',
  orderListUrl: '/basiCP/order/query',
  orderDetailUrl: '/basiCP/order/detail',
  orderConfirmUrl: '/basiCP/order/confirm',
  orderExpressUrl: '/basiCP/order/express',
  stockListUrl: '/basiCP/courseStockEx/query',
  studentListUrl: '/basiCP/stu/course/query',
  studentDetailUrl: '/basiCP/stu/course/detail',
  certListUrl: '/basiCP/cert/query',
  certDetailUrl: '/basiCP/cert/detail',
  printPreUrl: '/basiCP/cert/print/pre',
  expressPreUrl : '/basiCP/cert/express/pre',
  expressUrl: '/basiCP/cert/express',
};

export const ERR_OK = 0;

//模板下载地址
export const downLoadUrl = 'https://basi.xsuny.com/i/basi/excel/t/BASI-Batch-Add-Template.xlsx';